<template>
  <label
    class="label relative block pt-1 pl-9 mb-3 font-sans font-semibold text-xs text-white uppercase cursor-pointer"
  >
    <slot />
    <input
      :name="name"
      :value="optionValue"
      type="radio"
      :checked="isChecked"
      @change="changed"
    />
    <span class="checkmark z-20" />
    <span :style="{ backgroundColor: color }" class="color z-10" />
  </label>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    optionValue: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isChecked() {
      return this.value && this.value.id === this.optionValue.id
    },
  },
  methods: {
    changed($event) {
      this.$router.replace({
        query: {
          c: this.optionValue.slug,
          v: this.$route.query.v,
        },
      })
      this.$emit('input', this.optionValue)
    },
  },
}
</script>

<style lang="scss" scoped>
/* The label */
.label {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 27px;
}

.label input {
  @apply absolute opacity-0 cursor-pointer h-0 w-0;
}

.checkmark,
.color {
  @apply absolute pin rounded-full;

  height: 26px;
  width: 26px;
  border: 2px solid #c8cfdb;
}

.label input ~ .checkmark {
  transition: all 0.5s ease;
}

.label:hover input ~ .checkmark {
  @apply bg-white;
}

.label input:checked ~ .checkmark {
  background-color: rgba(255, 255, 255, 0.8);

  transition: all 0.5s ease;
}

.checkmark:after {
  @apply hidden absolute;

  content: '';
}

.label input:checked ~ .checkmark:after {
  @apply block;
}

.label .checkmark:after {
  left: 8px;
  top: 5px;
  width: 6px;
  height: 10px;
  border: solid #a5a5a5;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  transition: all 0.5s ease;
}
</style>
